import { render } from "./ForgottenPassword.vue?vue&type=template&id=69bb997a"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"
script.render = render

export default script